module.exports = __webpack_public_path__ + "images/pause.18953390.png";